<template>
  <!-- add face template Modal -->
  <div id="face_template" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
       <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Face Template</h5>
          <button type="button" class="btn-close" ref="Close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
            <div class="row">
              
                <div class="input-block">
                  <label class="col-form-label">Face Template Image</label>
                   <!-- <Field type="text" class="form-control disabled" name="template_image_path" v-model="company_role_id"
                    style="display:none;"></Field> -->
                  <Field class="form-control" type="file" v-model="template_image_path" accept="image/x-png,image/jpeg" id="template_image_path" name="template_image_path"
                    placeholder="face template Image" :class="{ 'is-invalid': errors.template_image_path }" />
                     <div class="invalid-feedback">{{ errors.template_image_path }}</div>
                  <div class="emailshow text-danger" id="template_image_path"></div>
                </div>
             
            </div>

            <div class="submit-section">
              <button class="btn btn-primary submit-btn" type="submit">
                <span v-if="!loader">Submit</span>
                <div class="spinner-border spinner-border-sm text-light" role="status" v-else>
                  <span class="visually-hidden">Loading...</span>
                </div>
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- /add face template Modal -->

  
</template>

<script>
import { Form, Field } from "vee-validate";
import axios from "axios";
import {VUE_APP_API_BASE_URL} from "../../config";
import * as Yup from "yup";
export default {
  components: {
    Form, Field
  },

  data() {
    return {
      loader: false,
      template_image_path:"",
      id:"",
    };
  },
  mounted() {
  },
  methods: {
    updateValues(item){
      this.id = item.id
    },

    async onSubmit(values) {
      this.loader = true;
      const formData = new FormData();
      
      if (values.template_image_path !== undefined) {
        formData.append("image", values.template_image_path);
      }
      formData.append("user_id", this.id);
      await axios.post(`${VUE_APP_API_BASE_URL}/face-template/add`, formData)
        .then((response) => {
          if (response.data.status === true) {
            this.$toast.success(response.data.message);
            this.$refs.Close.click();
            this.loader = false;
          } else {
            this.$toast.error(response.data.message || response.data.errors);
            this.loader = false;
            // this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
          this.loader = false;
        });
    },

  },



  setup() {
    const schema = Yup.object().shape({
      template_image_path: Yup.string().required("face template image is required")
     });

    return {
      schema,
    };
  },
}
</script>

<style scoped>
.pass-input.is-invalid+.toggle-password {
  bottom: 0;
}

.toggle-password {
  top: 49px !important;
  right: 28px;
  position: absolute;
}
</style>